import {
  SHIELD_STARTER,
  SHIELD_STARTER_HELTH_PLUS,
} from "@static/staticConstents";
import { get } from "lodash";

function generatePlanOverView(rawQuotaion: any, dispatch: Function) {
  //Create Plan Over view object which we will be passing to the hover menu
  let coverages = get(rawQuotaion, "coverages", []);
  const basePlan = coverages.find(
    (coverage: any) => coverage?.id === "shieldBasic"
  );
  const riderPlan =
    coverages.find((coverage: any) => coverage?.id === "shieldBasicRider") ||
    null;
  const isRider = riderPlan ? true : false;
  const selectedPlanName = isRider ? SHIELD_STARTER_HELTH_PLUS : SHIELD_STARTER;
  const basePlanPriceNoGst = get(basePlan, "attributes.modalPremium", null); // get(basePlan, "attributes.modalPremiumNoGST", null); //Changed the pricing to with GST pricing
  const riderPlanPriceNoGst = get(riderPlan, "attributes.modalPremium", null); //get(riderPlan, "attributes.modalPremiumNoGST", null); //Change the pricing to with GST as per the requirement
  const gst = get(basePlan, "attributes.bbbTotalGstToNodiscPremium", "-");
  const subTotalAmount = get(
    basePlan,
    "attributes.bbbSubTotalPremiumWGst",
    "-"
  );
  const discountEligibility = get(basePlan, "attributes.discountEligible");
  const promoCode = get(basePlan, "attributes.promoCodeSummary", "");
  const promoCodeLabel =
    promoCode && discountEligibility ? `(${promoCode})` : "";
  const promoCodeDiscount =
    promoCode && get(basePlan, "attributes.bbbPromoDiscWGST", "");
  const pormoCodeValue =
    promoCodeDiscount && discountEligibility ? `-S$${promoCodeDiscount}` : "-";
  const totalAmount = get(basePlan, "attributes.bbbSubTotalPremium", "");
  const totalCashPayble = get(basePlan, "attributes.totalCashOutlay", "");
  const MediSaveDeduction = get(
    basePlan,
    "attributes.bbbCpfMediSaveDeduction",
    ""
  );
  const planOverViewContainer = {
    basePlan,
    riderPlan,
    selectedPlanName,
    basePlanPriceNoGst,
    riderPlanPriceNoGst,
    gst,
    subTotalAmount,
    promoCode,
    promoCodeDiscount,
    promoCodeLabel,
    totalAmount,
    totalCashPayble,
    MediSaveDeduction,
    discountEligibility,
  };

  (
    Object.keys(planOverViewContainer) as (keyof typeof planOverViewContainer)[]
  ).forEach((x) => {
    if (
      !isNaN(planOverViewContainer[x]) &&
      planOverViewContainer[x] !== null &&
      planOverViewContainer[x] !== ""
    ) {
      planOverViewContainer[x] = Number(planOverViewContainer[x]).toFixed(2);
    }
  });

  const planOverviewList = [
    {
      heading: { text: "Plan Overview" },
      descriptions: [
        {
          text: "Plan Selected",
          value: `<div style='font-size:14px'>${selectedPlanName}</div>`,
        },
        {
          text: "Policy Term",
          value: `<div style="width:max-content">Yearly Renewable</div>`,
        },
        {
          text: "Premium Term",
          value: `<div style="width:max-content">Yearly Renewable</div>`,
        },
      ],
    },
    {
      heading: { text: "Annual Premium Breakdown*" },
      descriptions: [],
    },
  ];
  let withRiderContent = {
    text: `<div>${planOverViewContainer?.basePlan?.name}</div><div><ul style='margin-left:20px;margin-top:16px;'><li>${planOverViewContainer?.riderPlan?.name}</li></ul></div>`,
    value: `<div style="margin-bottom:16px">S$${planOverViewContainer?.basePlanPriceNoGst}</div><div>S$${planOverViewContainer?.riderPlanPriceNoGst}</div>
    `,
  };
  let withoutRiderContent = {
    text: `<div>${planOverViewContainer?.basePlan?.name}</div>`,
    value: `<div>S$${planOverViewContainer?.basePlanPriceNoGst}</div>`,
  };

  const mediSaveDeductionContent = {
    text: `<div>CPF MediSave deduction</div>`,
    value: `<div>-S$${planOverViewContainer?.MediSaveDeduction}</div>`,
  };

  planOverviewList[1].descriptions.push(
    isRider ? withRiderContent : withoutRiderContent,
    mediSaveDeductionContent
  );

  const subTotal = [
    {
      label: `<div>Promo Code <div style="font-weight: 600;line-height: 140%; width:max-content">${promoCode}${
        promoCode.endsWith("GST")
          ? "<span style='font-weight: 400'> (GST waiver for first year)</span>"
          : ""
      }</div><div>`,
      value: planOverViewContainer.promoCodeDiscount
        ? `-S$${planOverViewContainer.promoCodeDiscount}`
        : "-",
    },
  ];

  const summary = {
    text: `<div><div style="font-weight: 600;font-size: 18px;line-height: 140%;">Cash Payment</div><div style="color: #434343;font-size: 12px;font-weight: 500;">(after CPF MediSave Deduction)</div><div style="color: #434343;font-size: 12px;font-weight: 500;margin-top:24px">*Premiums quoted after GST</div></div>`,
    value: `<div style="font-size: 18px;font-weight: 600;color: #883E89;margin-top: -30px">S$${planOverViewContainer.totalCashPayble}</div>`,
  };
  return {
    planOverviewList,
    subTotal,
    summary,
    PlanOverViewData: planOverViewContainer,
  };
}

export { generatePlanOverView };
